// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MNGY","left":"styles_left__1YUHG","desktopActions":"styles_desktopActions__3WH3q","title":"styles_title__lJg7Z"};